export class RemoteDatabaseAccessData {
    constructor(public Id: number, public UserId: number, public RemoteUserName: string) {
    }
}